module.exports = __webpack_public_path__ + "img/agpz-car-disabled.d21db2c8.svg";